import { FC, useState } from 'react';
import { Grid, TextField, Button, Autocomplete } from '@mui/material';
import { AU_STATES } from '@constants';
import { AvaDepotClustersView } from './AvaDepotClustersView';

const AvaDepotClusteringScreen: FC = () => {
  const [searchStateValue, setSearchStateValue] = useState('');
  const [searchState, setSearchState] = useState('');

  return (
    <>
      <Grid container alignItems="center" spacing={2} p={2}>
        <Grid item xs={10}>
          <Autocomplete
            id="state-search"
            data-testid="states-searchbar"
            onChange={(e, newValue) => {
              setSearchStateValue(newValue ? newValue.id : '');
            }}
            options={AU_STATES || null}
            getOptionLabel={(option) => `${option.id} - ${option.value}`}
            disablePortal
            renderInput={(params) => <TextField {...params} label="Search by state" />}
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            type="submit"
            onClick={() => setSearchState(searchStateValue)}
            data-testid="seatch-store-clusters-by-state-button"
          >
            Search
          </Button>
        </Grid>
      </Grid>
      {searchState !== '' && <AvaDepotClustersView searchState={searchState} />}
    </>
  );
};

export default AvaDepotClusteringScreen;
